import { AutoLockFormsLevelType, FormNames, NotesFieldNames } from '../autoLockForms.constants';

const formFields = [
  {
    name: NotesFieldNames.NOTES,
    label: 'Notes',
    levelType: AutoLockFormsLevelType.FIELD,
  },
];

export const notesForm = {
  name: FormNames.NOTES,
  label: 'Notes',
  levelType: AutoLockFormsLevelType.FORM,
  children: formFields,
};
